import { Phone, Mail, Clock, MapPin } from "lucide-react";
import LeadForm from "@/components/LeadForm";
import { CONTACT } from "@/lib/constants";

export default function Contact() {
    return (
        <div data-testid="contact-page" className="container-tight py-16 md:py-24">
            <div className="border-b border-zinc-800 pb-10 mb-12">
                <div className="eyebrow">Contact</div>
                <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter text-white mt-3">
                    Talk to a printer expert.
                </h1>
                <p className="text-zinc-400 mt-4 max-w-2xl leading-relaxed">
                    Buying advice, bulk orders, or a stubborn wireless setup — we&apos;re happy to help.
                    Call, email, or drop us a message and we&apos;ll respond within one business day.
                </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
                <div className="lg:col-span-5 space-y-6">
                    <a
                        href={CONTACT.phoneHref}
                        data-testid="contact-phone-card"
                        className="group card-flat p-6 md:p-8 block hover:border-blue-500/60 transition-colors duration-200"
                    >
                        <div className="flex items-start gap-4">
                            <div className="h-11 w-11 rounded-sm bg-blue-600/15 border border-blue-600/30 flex items-center justify-center flex-shrink-0">
                                <Phone className="h-5 w-5 text-blue-400" />
                            </div>
                            <div className="min-w-0">
                                <div className="eyebrow">Call us — Toll free</div>
                                <div className="font-display text-2xl md:text-3xl font-bold text-white mt-2 tracking-tight group-hover:text-blue-400 transition-colors" data-testid="contact-phone-number">
                                    {CONTACT.phoneDisplay}
                                </div>
                                <div className="text-sm text-zinc-500 mt-2 inline-flex items-center gap-2">
                                    <Clock className="h-3.5 w-3.5" /> {CONTACT.hours}
                                </div>
                            </div>
                        </div>
                    </a>

                    <div className="card-flat p-6 md:p-8">
                        <div className="flex items-start gap-4">
                            <div className="h-11 w-11 rounded-sm bg-zinc-900 border border-zinc-800 flex items-center justify-center flex-shrink-0">
                                <Mail className="h-5 w-5 text-zinc-300" />
                            </div>
                            <div>
                                <div className="eyebrow">Email</div>
                                <a href={CONTACT.emailHref} className="font-display text-lg text-white mt-2 block hover:text-blue-400 transition-colors" data-testid="contact-email">
                                    {CONTACT.email}
                                </a>
                                <div className="text-xs text-zinc-500 mt-2">For editorial, partnerships, and press.</div>
                            </div>
                        </div>
                    </div>

                    <div className="card-flat p-6 md:p-8">
                        <div className="flex items-start gap-4">
                            <div className="h-11 w-11 rounded-sm bg-zinc-900 border border-zinc-800 flex items-center justify-center flex-shrink-0">
                                <MapPin className="h-5 w-5 text-zinc-300" />
                            </div>
                            <div>
                                <div className="eyebrow">Response time</div>
                                <div className="text-sm text-zinc-200 mt-2 leading-relaxed">
                                    Weekday inquiries typically get a response within 1 business day.
                                    Urgent questions? The phone is always faster.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="text-xs text-zinc-500 leading-relaxed border-l-2 border-zinc-800 pl-4">
                        We take privacy seriously. Information submitted here is used only to reply to your inquiry
                        and is never sold or shared with third parties. See our{" "}
                        <a href="/privacy" className="text-blue-400 hover:text-blue-300">privacy policy</a> for details.
                    </div>
                </div>

                <div className="lg:col-span-7">
                    <LeadForm source="contact-page" />
                </div>
            </div>
        </div>
    );
}
